<template>
    <div class="login-and-signin">
        <div class="login-and-signin-banner">
            <div class="login-and-signin-layout">
                <div class="login-and-signin-title">
                    Log In to Online Learning Hub
                </div>
                <div class="login-and-signin-form">
                    <div class="login-and-signin-form-title">
                        Email Address
                    </div>
                    <div class="login-and-signin-form-column">
                        <el-input v-model="loginForm.email" />
                    </div>
                    <div class="login-and-signin-form-title">
                        Password
                    </div>
                    <div class="login-and-signin-form-column">
                        <el-input v-model="loginForm.pwd" type="password" />
                    </div>
                    <div class="login-and-signin-form-submit">
                        <el-button @click="login()" v-loading="isButtonLoading">
                            Login
                        </el-button>
                    </div>
                    <div class="login-and-signin-form-forgot-pwd">
                        <a href="#">
                            Forget password?
                        </a>
                    </div>
                </div>
            </div>
            <div class="login-and-signin-layout">
                <div class="login-and-signin-title">
                    Sign Up to Online Learning Hub
                </div>
                <div class="login-and-signin-form">
                    <el-form :model="signInForm" :rules="rules" ref="signInForm">
                        <div class="login-and-signin-form-title">
                            Full Name
                        </div>
                        <div class="login-and-signin-form-column">
                            <el-input v-model="signInForm.fullname" />
                        </div>
                        <div class="login-and-signin-form-title">
                            Email Address
                        </div>
                        <div class="login-and-signin-form-column">
                            <el-input v-model="signInForm.email" />
                        </div>
                        <div class="login-and-signin-form-double-column pc">
                            <div class="login-and-signin-form-column">
                                <div class="login-and-signin-form-title-pwd">
                                    <el-form-item label="Password" prop="pwd">
                                        <div class="login-and-signin-form-column-pwd">
                                            <el-input v-model="signInForm.pwd" type="password"/>
                                        </div>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="login-and-signin-form-column login-and-signin-form-column-right">
                                <div class="login-and-signin-form-title-pwd">
                                    <el-form-item label="Confirm Password" prop="confirmPwd">
                                        <div class="login-and-signin-form-column-pwd">
                                            <el-input v-model="signInForm.confirmPwd" type="password"/>
                                        </div>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div class="mobile">
                            <div class="login-and-signin-form-title">
                                <el-form-item label="Password" prop="pwd">
                                    <div class="login-and-signin-form-column">
                                        <el-input v-model="signInForm.pwd" type="password"/>
                                    </div>
                                </el-form-item>
                            </div>
                            <div class="login-and-signin-form-title">
                                <el-form-item label="Confirm Password" prop="confirmPwd">
                                    <div class="login-and-signin-form-column">
                                        <el-input v-model="signInForm.confirmPwd" type="password"/>
                                    </div>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="login-and-signin-form-terms">
                            <div class="login-and-signin-form-term">
                                <div class="login-and-signin-form-term-checkbox">
                                    <el-checkbox v-model="signInForm.term1" />
                                </div>
                                <div class="login-and-signin-form-term-point">
                                    I agree to receive instructional and promotional emails
                                </div>
                            </div>
                            <div class="login-and-signin-form-term">
                                <div class="login-and-signin-form-term-checkbox">
                                    <el-checkbox v-model="signInForm.term2" />
                                </div>
                                <div class="login-and-signin-form-term-point">
                                    I agree to Teachable’s Terms of Use & Privacy Policy and Everyday Chinese’s Terms of Use & Privacy Policy
                                </div>
                            </div>
                        </div>
                        <div class="login-and-signin-form-submit">
                            <el-button @click="signUp()" v-loading="isButtonLoading">
                                Sign Up
                            </el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Login',
        data() {
            var validatePwd = (rule, value, callback) => {
                if (value !== this.signInForm.pwd) {
                    callback(new Error('Password is different'));
                } else {
                    callback();
                }
            };
            return {
                loginForm: {
                    email: '',
                    pwd: ''
                },
                signInForm: {
                    fullname: '',
                    email: '',
                    pwd: '',
                    confirmPwd: '',
                    term1: false,
                    term2: false
                },
                rules: {
                    confirmPwd:[
                        { validator: validatePwd, trigger: 'blur' }
                    ],
                },
                regForm:{},
                isButtonLoading: false,
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {

            },
            login() {
                this.isButtonLoading = true;

                this.$api.request('System/login', this.loginForm).then((result) => {
                    if (result.status == true) {
                        localStorage.setItem('token', result.data.token);
                        this.$message.success('Login successfully');

                        setTimeout(function() {
                            window.location = '/index';
                        }, 2000);
                    } else {
                        this.isButtonLoading = false;

                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.isButtonLoading = false;

                    this.$message.error(error.msg);
                });
            },
            signUp() {
                this.$refs['signInForm'].validate((valid) => {
                    if (valid) {
                        this.regForm = {'name': this.signInForm.fullname, 'email': this.signInForm.email, 'pwd': this.signInForm.pwd};
                        this.$api.request('System/reg', this.regForm).then((result) => {
                            if (result.status == true) {
                                this.$message.success('Register successfully');
                                this.resetForm();
                            } else {
                                this.isButtonLoading = false;
                                this.$message.error(result.msg);
                            }
                        }).catch(error => {
                            this.isButtonLoading = false;
                            this.$message.error(error.msg);
                        });
                    } else {
                        return false;
                    }
                });
            },
            resetForm(){
                this.$refs['signInForm'].resetFields();
            }
        }
    }
</script>
<style lang='scss' type='text/css'>
    @import '../styles/pc/Login.scss';
    @import '../styles/mobile/Login.scss';
</style>
